import React from 'react';
import './App.scss';
import { Header } from './components/Header';
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";


//Declare New Components Here
import Home from './components/Home';
import PersonalDetails from "./components/PersonalDetails.jsx";
import FundTransfer from "./components/FundTransfer";
import ReviewDetails from "./components/ReviewDetails";
import errorscreen from "./components/error";

function App() {
  return (
    <Router>
      <div className="content">
        <Header projectName={'mbank_fundtransfer'} />
        <Route exact path="/" ><Redirect to="/fundtrf" /></Route>
        <Route exact path="/fundtrf" component={Home} />
        <Route path="/fundtrf/PersonalDetails" component={PersonalDetails} />
        <Route path="/fundtrf/FundTransfer" component={FundTransfer} />
        <Route path="/fundtrf/ReviewDetails" component={ReviewDetails} />
        <Route path="/fundtrf/error" component={errorscreen} />
      </div>
      <br></br><br></br>
    </Router>
  );
}


export default App;
